import { ContentLabel } from "@workshop/types";
import { AccountGroupType } from "features/account-groups-form/accountsGroups.model";

type WorkshopSelectorState = {
  workshop: {
    contentLabels: ContentLabel[] | null;
    isLoading: boolean;
    loadingTopicLabelIds: string[];
    selectedGroup: AccountGroupType | null;
    selectedContentLabel: ContentLabel | null;
  };
};

export const getAllContentLabels = (state: WorkshopSelectorState) =>
  state.workshop.contentLabels;
export const getIsLoadingContentLabels = (state: WorkshopSelectorState) =>
  state.workshop.isLoading;
export const getLoadingTopicLabelIds = (state: WorkshopSelectorState) =>
  state.workshop.loadingTopicLabelIds;
export const getSelectedGroup = (state: WorkshopSelectorState) =>
  state.workshop.selectedGroup;
export const getSelectedContentLabel = (state: WorkshopSelectorState) =>
  state.workshop.selectedContentLabel;
